import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Turnstile } from '@marsidev/react-turnstile';
import axios from 'axios';
import CpfInput from '../../components/external/CpfInput';
import DataNascimentoInput from '../../components/external/DataNascimentoInput';
import Modal from '../../components/external/Modal';
import '../../styles/external/App.css';
import { useEnvValue } from '../../config/env';

export default function Login() {
    const navigate = useNavigate();
    const SITE_KEY = useEnvValue('REACT_APP_TURNSTILE_SITE_KEY');
    const API_BASE_URL = useEnvValue('REACT_APP_URL_API');

    const [cpf, setCpf] = useState('');
    const [dataNascimento, setDataNascimento] = useState('');
    const [senha, setSenha] = useState('');
    const [captchaToken, setCaptchaToken] = useState(null);
    const [modalData, setModalData] = useState({ show: false, title: '', message: '' });

    const isFormValido = () => {
        return cpf.trim() !== '' && dataNascimento.trim() !== ''; // && senha.trim() !== ''
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!captchaToken) {
            alert('Por favor, confirme o captcha.');
            return;
        }

        try {
            const csrfRes = await axios.get(`${API_BASE_URL}/csrf/token`, {
                withCredentials: true,
            });

            const csrfToken = csrfRes.data?.csrfToken;

            const authResponse = await axios.post(
                `${API_BASE_URL}/auth/token`,
                { tipo: 'INTEGRACAO' },
                {
                    headers: { 'X-CSRF-Token': csrfToken },
                    withCredentials: true,
                }
            );

            const token = authResponse.data?.access_token;
            if (!token) throw new Error('Token não retornado pela API.');

            await axios.post(
                `${API_BASE_URL}/notas/validar-cliente`,
                {
                    cpf,
                    dataNascimento,
                    turnstileToken: captchaToken,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'X-CSRF-Token': csrfToken,
                    },
                    withCredentials: true,
                }
            );

            localStorage.setItem('access_token', token);
            localStorage.setItem('cpf', cpf);
            localStorage.setItem('dataNascimento', dataNascimento);

            navigate('/dashboard');
        } catch (error) {
            console.error('Erro no login:', error);
            const mensagemErro =
                error.response?.data?.message ||
                'CPF, senha ou data de nascimento inválidos. Tente novamente.';
            setModalData({
                show: true,
                title: 'Erro ao entrar',
                message: mensagemErro,
            });
        }
    };

    return (
        <div className="container">
            <Modal
                show={modalData.show}
                title={modalData.title}
                message={modalData.message}
                onClose={() => setModalData({ ...modalData, show: false })}
            />

            <div className="left">
                <form className="form form--narrow" onSubmit={handleSubmit}>
                    <CpfInput value={cpf} onChange={(e) => setCpf(e.target.value)} />
                    <DataNascimentoInput value={dataNascimento} onChange={(e) => setDataNascimento(e.target.value)} />

                    <div className="captcha-box">
                        {SITE_KEY ? (
                            <Turnstile
                                siteKey={SITE_KEY}
                                onSuccess={(t) => setCaptchaToken(t)}
                                onExpire={() => setCaptchaToken(null)}
                                onError={() => {
                                    console.error('Turnstile falhou ao renderizar (verifique AdBlock/CSP/host permitido).');
                                    setCaptchaToken(null);
                                }}
                                options={{ appearance: 'always', theme: 'light' }}
                            />
                        ) : (
                            <small style={{ color: '#c00' }}>
                                Captcha indisponível: configure a key e reinicie o servidor.
                            </small>
                        )}
                    </div>

                    <button type="submit" className="button" disabled={!isFormValido()}>
                        Ver Notas
                    </button>
                </form>
            </div>
        </div>
    );
}
